import { ReactNode } from 'react'
import {atomValOrUpdate} from '../store/reducers/reducer'

export const errorCatch = (setter: atomValOrUpdate<any>, placeholder: ReactNode) => {
    setter({isLoaded: true, data: [], placeholder})
}